export const navigationLinks = [
  {
    title: "Om skolen",
    href: "/om-skolen",
    children: [
      { title: "Om os", href: "/side/om-os", desc: "Vores historie og friskolegrundlag" },
      { title: "Værdigrundlag", href: "/side/vaerdigrundlag", desc: "Tryghed, demokrati og dannelse" },
      { title: "Optagelse og indmeldelse", href: "/side/optagelse-og-indmeldelse", desc: "Optagelsesprocedure med MitID og kriterier" },
      { title: "Prøve- og karakterfri", href: "/side/eksamensfri", desc: "Læring uden karakterræs og tests" },
      { title: "Personale", href: "/medarbejdere", desc: "Mød hverdagens superhelte på OLF" },
      { title: "Bestyrelse & udvalg", href: "/side/bestyrelse-udvalg", desc: "Bestyrelsesmedlemmer, ForældreForum og ARDU" },
      { title: "Vedtægter", href: "/side/vedtaegter", desc: "Skolens formelle vedtægter godkendt af UVM" }
    ]
  },
  {
    title: "Sådan gør vi",
    href: "/saadan-goer-vi",
    children: [
      { title: "Politikker", href: "/side/politikker", desc: "Trivselspolitik og særlige behov" },
      { title: "Evaluering & Tests", href: "/side/evaluering-tests", desc: "Udviklingsplaner og støtteundervisning" },
      { title: "Fælles mål", href: "/side/faelles-maal", desc: "Kompetencemål og UU-vejledning" },
      { title: "Klasser & Grupper", href: "/side/klasser-grupper", desc: "Farvegrupper, storgrupper og familiegrupper" },
      { title: "Læseplaner", href: "/side/laeseplaner", desc: "Fag, KIF og undervisningsplaner" },
      { title: "Traditioner", href: "/side/traditioner", desc: "Samfundsleg, lejrskoler, morgensang og basar" },
      { title: "Tilsyn", href: "/side/tilsyn", desc: "Forældrevalgt eksternt tilsyn og rapporter" },
      { title: "Undervisningsmiljø vurdering", href: "/side/undervisningsmiljoe-vurdering", desc: "Trivselsmålinger og UVM rapporter" },
      { title: "Nøgletal", href: "/side/noegletal", desc: "Overgang til ungdomsuddannelser" },
      { title: "Evaluering af skolen", href: "/side/evaluering-af-skolen", desc: "Systematisk to-årlig evaluering" }
    ]
  },
  {
    title: "På OLF",
    href: "/paa-olf",
    children: [
      { title: "Elev", href: "/side/elev", desc: "Hverdag, medansvar, mobilfri skole og trivsel" },
      { title: "Udlandsrejse", href: "/side/udlandsrejse", desc: "12 dages dannelsesrejse i 9. klasse" },
      { title: "Forældre", href: "/side/foraeldre", desc: "Forventninger, arbejdsdage og samarbejde" },
      { title: "OLF Sangen", href: "/side/olf-sangen", desc: "Glade børn lærer mest – noder og tekst" },
      { title: "Billedgallerier", href: "/gallerier", desc: "Glimt fra skolelivet og oplevelser" }
    ]
  },
  {
    title: "Fritteren",
    href: "/side/fritteren"
  },
  {
    title: "Støttekredsen",
    href: "/side/stoettekredsen"
  },
  {
    title: "Musikskole",
    href: "/side/musikskole"
  },
  {
    title: "Nyheder",
    href: "/nyheder"
  },
  {
    title: "Kontakt",
    href: "/kontakt"
  }
];

export const schoolInfo = {
  name: "ODDER LILLE FRISKOLE",
  tagline: "Glade børn lærer mest",
  cvr: "77369619",
  phone: "86 54 38 66",
  phoneRaw: "86543866",
  email: "olf@odderlillefriskole.dk",
  lederEmail: "dmt@odderlillefriskole.dk",
  address: "Randlevvej 4",
  city: "8300 Odder",
  fullAddress: "Randlevvej 4, 8300 Odder",
  hoursFritterMonThu: "06.45 – 16.30",
  hoursFritterFri: "06.45 – 16.00",
  logoUrl: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-lille-friskole-bt.png",
  logoWhiteUrl: "https://assets.auxodev.dk/assets/7e157867-df92-46f8-b5ca-20179d4d9044/odder-lille-friskole-logo-white-smaller-text-1-5324bf84.png"
};
